import { Storage } from "@ionic/storage-angular";
import { Injectable, inject } from "@angular/core";
export const KEPT_ON_LOGOUT_IMAGE_CACHES = [
  "guidanceInformation",
  "mmControlInventoryOffline",
];
export const imageCacheTenantKey = (key: string) => `${key}_tenant`;

@Injectable({
  providedIn: "root",
})
export class StorageService {
  private _ready: Promise<void>;
  private storage: Storage = inject(Storage);

  constructor() {
    this._ready = this.init();
  }

  private async init() {
    await this.storage.create();
  }

  public async ready() {
    return this._ready;
  }

  // Every call waits for create() — on a page reload the auth guard reads
  // "user" immediately, and Ionic Storage throws if the DB isn't open yet,
  // which the guard treats as "not logged in" and redirects to /login.
  public clear = async () => {
    await this._ready;
    return await this.storage.clear();
  };
  public clearExcept = async (keep: string[]) => {
    await this._ready;
    const keys = await this.storage.keys();
    await Promise.all(
      keys
        .filter((key) => !keep.includes(key))
        .map((key) => this.storage.remove(key)),
    );
  };
  public get = async (key: string) => {
    await this._ready;
    return await this.storage.get(key);
  };
  public remove = async (key: string) => {
    await this._ready;
    await this.storage.remove(key);
  };
  public set = async (key: string, value: any) => {
    await this._ready;
    await this.storage?.set(key, value);
  };
}
